import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, INotification } from "src/services/types";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { Button, Card, CardBody, Col, Collapse, Row } from "reactstrap";
import { columnsNotifications } from "./ColumnsNotification";
import { fetchNotificationsSent } from "src/services/notification-manage-service";
import { UsersWhomNotificationWasSent } from "./UsersWhomNotificationWasSent";
import { CreateNotificationComponent } from "./CreateNotificationComponent";
import FeatherIcon from "feather-icons-react";

export const NotificationManager = () => {
    document.title = "Secure | Notifications Manager";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [eventNotifications, setEventNotifications] = useState<INotification[]>([]);
  const [notificationSelected, setNotificationSelected] = useState<INotification | null>(null);
  const [showUsersModal, setShowUsersModal] = useState(false);
  const [isOpenCreateNotification, setIsOpenCreateNotification] = useState(false);

  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
      read_status: 1, // 1 for unread
  });

  const fetchData = async (config: IConfig) => {
    setIsLoading(true);
    const res = await fetchNotificationsSent(config)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res?.data?.pagination?.total);
        setEventNotifications(res.data.data);
        
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const onShowUsers = async (item: INotification, usersAux: INotification[] = [] ) => {
    setNotificationSelected(item);
    setShowUsersModal(true);
  }

  const refresh = () => {
    fetchData(config);
  }

  useEffect(() => {
    fetchData(config);
  }, [config]);


  return (
    <>
      <div className="page-content">
          <h2 className="text-primary">Notification Manager</h2>
          <Card>
            <CardBody className="">
              
              <div className={`d-flex ` + (isOpenCreateNotification ? 'justify-content-end mb-3' : '')} >
                <Button color={isOpenCreateNotification ? 'danger' : 'primary'} onClick={() => setIsOpenCreateNotification(!isOpenCreateNotification)} >
                  <div className="d-flex align-items-center justify-content-center" >
                    <FeatherIcon icon={isOpenCreateNotification ? "x" : "plus"} />
                    <div>
                      {isOpenCreateNotification ? 'Close Create Notification' : 'Create New Notification'} 
                    </div>
                  </div>
                </Button>
              </div>
               
              <Collapse isOpen={isOpenCreateNotification} >
                <CreateNotificationComponent 
                  refreshTable={refresh}
                  isOpenCreateNotification={isOpenCreateNotification}
                />
              </Collapse>

            </CardBody>
          </Card>
          <Row className="mb-2">
              <Col sm={6} className="d-flex align-items-end justify-content-start gap-2">
                <div>
                    <button
                      type="button"
                      className="btn btn-soft-primary waves-effect waves-light"
                      onClick={refresh}
                    >
                      <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                </div>
              </Col>
              <Col sm={6} className="d-flex justify-content-end align-items-end" >
                  <div className="w-75">
                    <SearchTable 
                      onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                      loading={isLoading && !!config.search}
                      placeholder="Search by Title and Body ..."
                    />
                  </div>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                customStyles={{
                    rows: { style: { minHeight: '50px' }},
                    table: { style: { minHeight: '400px'}},
                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                }}
                columns={
                  columnsNotifications(
                    config, 
                    onShowUsers 
                  )
                  }
                data={eventNotifications}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                responsive
                onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                onChangePage={(page) => setConfig({ ...config, page })}
                paginationDefaultPage={config.page}
                paginationPerPage={config.per_page}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                noDataComponent={
                    <SectionNoData
                        onRefresh={() => fetchData(config)}
                        isLoading={isLoading}
                    />
                }
              />
          </ContentDataTable>
      </div>

        <UsersWhomNotificationWasSent
            show={showUsersModal}
            onClose={() => (setNotificationSelected(null), setShowUsersModal(false))}
            notification={notificationSelected!}
        />

    </>
  )
}
